import { defineAsyncComponent } from 'vue'
export default {
  blank: defineAsyncComponent(() => import("/opt/buildhome/repo/layouts/blank.vue")),
  "components-default-layout-with-vertical-nav": defineAsyncComponent(() => import("/opt/buildhome/repo/layouts/components/DefaultLayoutWithVerticalNav.vue")),
  "components-nav-items": defineAsyncComponent(() => import("/opt/buildhome/repo/layouts/components/NavItems.vue")),
  "components-navbar-theme-switcher": defineAsyncComponent(() => import("/opt/buildhome/repo/layouts/components/NavbarThemeSwitcher.vue")),
  "components-user-profile": defineAsyncComponent(() => import("/opt/buildhome/repo/layouts/components/UserProfile.vue")),
  default: defineAsyncComponent(() => import("/opt/buildhome/repo/layouts/default.vue"))
}